import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/of';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/share';

import { CacheService  } from '../core/cache.service';
import { ApiService  } from '../core/api.service';
import { Mappings} from '../../shared/mapping';
import { LanguageService } from "./language.service";

@Injectable()
export class NewsletterService 
{
  constructor
  (
    public _api: ApiService, 
    public _cache: CacheService,
    private languageService: LanguageService,
    private mappings: Mappings
  ) {}

  //getting language
  lang = this.languageService.getLongLang();

  newsletterSubscribe(email: string) 
  {
    let url = this.mappings.Web_Api_Post_Newsletter_Subscribe.replace('{email}', email).replace('{lang}', this.lang);

    return this._api.get(url);
  }

  getNewsletterPageData()
  {
    let url = this.mappings.Web_Api_Get_Newsletter_Page_Data.replace('{lang}', this.lang);

    return this._api.get(url);
  }
  
  getNewsletterConfirmationPageData()
  {
    let url = this.mappings.Web_Api_Get_Newsletter_Confirmation_Page_Data.replace('{lang}', this.lang);

    return this._api.get(url)
  }
}


// WEBPACK FOOTER //
// ./src/../~/angular2-template-loader!./src/+app/services/cms/newsletter.service.ts